$shm_hitalama_components_editor $mol_page
	definition $shm_hitalama_map_widget_entity_custom
	saving false
	title \Код
	minimal_width 960
	title_content /
		<= Title_text $mol_view
			sub / <= title
	body <= content /$mol_view
	Save_status $mol_status
		status <= save_status \
	Deck $mol_deck
		Switch => Deck_switch
		Content => Deck_content
		items /
			<= Tree $shm_hitalama_components_source
				definition <= definition
				kind \tree
				enabled <= editable false
				title \view.tree
			<= Logic $shm_hitalama_components_source
				definition <= definition
				kind \logic
				enabled <= editable
				title \TypeScript
			<= Style $shm_hitalama_components_source
				definition <= definition
				kind \style
				enabled <= editable
				title \Стили
			<= Dependencies $shm_textarea_code
				sidebar_showed true
				enabled <= editable
				title \Зависимости
				value? <=> dependencies? \
				hint \FQN ссылка-на-определение — по одной на строку
			<= Default $shm_hitalama_components_source
				definition <= definition
				kind \default
				enabled <= editable
				title \Дефолт-виджет
			<= Readme $shm_hitalama_components_source
				definition <= definition
				kind \readme
				enabled <= editable
				title \Readme
			<= Demo $shm_hitalama_components_source
				definition <= definition
				kind \demo
				enabled <= editable
				title \demo.ts
